import type { MoneyFieldConfig } from '@/modules/application-tracker/components/lease-form';

import { INVITE_LEASE_DETAILS_VALIDATION_MESSAGES as MSG } from './constants';
import { grossMonthlyRentValidate, moneyValidate } from './invite-lease-details.field-schemas';

export const INVITE_RENT_FIELDS = {
  grossMonthlyRent: {
    kind: 'money',
    visible: true,
    required: true,
    requiredMessage: MSG.BASE_MONTHLY_RENT_REQUIRED,
    label: 'Base monthly rent',
    helperText:
      'Monthly rent before any concessions or discounts. Do not include any additional fees (e.g., utilities, pet rent, parking, trash).',
    validate: grossMonthlyRentValidate,
  },
  freeRent: {
    kind: 'money',
    visible: true,
    required: false,
    rowGroup: 'rent-extras',
    label: 'Rent concession',
    helperText: 'Total amount of free rent or concessions offered to the renter.',
    fixedDecimalScale: true,
    validate: moneyValidate,
  },
  prepaidRent: {
    kind: 'money',
    visible: true,
    required: false,
    rowGroup: 'rent-extras',
    label: 'Prepaid rent',
    helperText: 'Any rent that will be collected at lease signing.',
    fixedDecimalScale: true,
    validate: moneyValidate,
  },
} satisfies Record<string, MoneyFieldConfig>;
